/**
 * Opções fixas da barra de ferramentas do `app-rich-text-editor`.
 *
 * Os valores são os do Quill 2 padrão: `header` 1..3, `size` com as classes `ql-size-small`,
 * `ql-size-large` e `ql-size-huge`, `align` com `ql-align-*`. Quem renderiza o HTML fora do editor
 * (o PDF do backend, por exemplo) precisa ter CSS para essas classes.
 */

export interface RichTextOption<T> {
  label: string;
  value: T;
}

/** Estilo do parágrafo. `false` = texto normal. */
export const RICH_TEXT_PARAGRAPH_STYLES: RichTextOption<number | false>[] = [
  { label: 'Texto normal', value: false },
  { label: 'Título 1', value: 1 },
  { label: 'Título 2', value: 2 },
  { label: 'Título 3', value: 3 },
];

/** Tamanho da fonte. `false` = normal. */
export const RICH_TEXT_SIZES: RichTextOption<string | false>[] = [
  { label: 'Pequeno', value: 'small' },
  { label: 'Normal', value: false },
  { label: 'Grande', value: 'large' },
  { label: 'Enorme', value: 'huge' },
];

/** Alinhamentos. `false` = à esquerda (padrão do Quill, sem classe). */
export const RICH_TEXT_ALIGNMENTS: { value: string | false; icon: string; tooltip: string }[] = [
  { value: false, icon: 'pi pi-align-left', tooltip: 'Alinhar à esquerda' },
  { value: 'center', icon: 'pi pi-align-center', tooltip: 'Centralizar' },
  { value: 'right', icon: 'pi pi-align-right', tooltip: 'Alinhar à direita' },
  { value: 'justify', icon: 'pi pi-align-justify', tooltip: 'Justificar' },
];

/**
 * Paleta das cores de texto e destaque, no estilo dos editores de documento: tons neutros na
 * primeira linha e as cores da marca e de sinalização nas demais.
 */
export const RICH_TEXT_PALETTE: string[] = [
  '#000000',
  '#434343',
  '#666666',
  '#999999',
  '#cccccc',
  '#ffffff',
  '#000a28',
  '#1d4ed8',
  '#0891b2',
  '#15803d',
  '#ca8a04',
  '#b91c1c',
  '#dbeafe',
  '#cffafe',
  '#dcfce7',
  '#fef9c3',
  '#ffedd5',
  '#fee2e2',
];

/** Recuo máximo do Quill (`ql-indent-1` .. `ql-indent-8`). */
export const RICH_TEXT_MAX_INDENT = 8;

/** Token de variável no texto: `{{chave}}`, mesma regra do backend (`PartnerContractVariables`). */
export const RICH_TEXT_VARIABLE_PATTERN = /\{\{\s*([a-zA-Z0-9_.]+)\s*\}\}/g;

/** Formatos inline que "Limpar formatação" remove. Formatos de bloco (tabela, lista) ficam. */
export const RICH_TEXT_INLINE_FORMATS = [
  'bold',
  'italic',
  'underline',
  'strike',
  'color',
  'background',
  'size',
  'link',
];
